import StationShow from './StationShow'
import StationList from './StationList'

export default {
  list: StationList,
  show: StationShow,
}
